import { ExternalClient } from 'interfaces/auth';
import api from '../api';

export const ServiceExterno = {
  generateReport: (user: ExternalClient): Promise<void> =>
    api.post('/rotas/auditoria/externo', { ...user }),
};

